var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt15",
          attrs: { model: _vm.rules, rules: _vm.rule },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "remarks" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "255",
                  "show-word-limit": "",
                  rows: 4,
                  placeholder: _vm.$t("customer.placeholder18"),
                },
                model: {
                  value: _vm.rules.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "remarks", $$v)
                  },
                  expression: "rules.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }